import * as React from 'react'

import { Avatar } from '@material-ui/core'
import defaultAvatar from 'assets/img/default-avatar.png'
import parentImg from 'assets/img/parent.svg'
import { GameInstallationModal, ProgressionEvaluationModal } from 'components'
import IForm from 'data/questionnaires/IForm'
import { isMobile } from 'react-device-detect'
import { connect } from 'react-redux'
// import { isMobile } from 'react-device-detect'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { _route } from 'routes/config'
// import { getDeviceLink } from 'services/downloadApp'
import { getGamesCount } from 'services/games'
import { getQuestionnairesCount } from 'services/questionnaires'
import SnackbarService from 'services/snackbars'
import { getAge } from 'services/utils'
import IPatient from 'types/store/patients/patients/patient'
import Content from './content'
import './style.scss'

interface IReduxStateProps {
  patientDetail: IPatient
  user: any
  plusUser: any
}

interface IReduxDispatchProps {}

interface IReduxProps extends IReduxStateProps, IReduxDispatchProps {}

export interface INativeProps {
  form: IForm
  completed?: boolean
  openPlusOnlyPopup: () => void
  openEvaluationWarningModal: () => void
}

interface IProps
  extends INativeProps,
    IReduxProps,
    RouteComponentProps<{ id: string }> {}

export interface IState {
  progressionEvaluationModalOpen: boolean
  gameInstallationModalOpen: boolean
}

class PatientForm extends React.PureComponent<IProps, IState> {
  state = {
    progressionEvaluationModalOpen: false,
    gameInstallationModalOpen: false
  }

  renderAvatar = (array: any[]) =>
    array.slice(0, 3).map((assigned, index) => {
      const user = assigned.find(assign => assign.userAvatar)

      return (
        <Avatar
          className="parent-avatar"
          // alt={'no image'}
          src={user && user.userAvatar ? user.userAvatar : defaultAvatar}
          key={index}
        />
      )
    })

  getImages = (values: any[], completed: boolean) =>
    values
      .filter(
        item =>
          Array.isArray(item) &&
          item.find(childItem => childItem && childItem.completed === completed)
      )
      .map(item => item.find(assigned => assigned.userAvatar).userAvatar)
      .map(i => parentImg)

  baseResponseMissing = (): boolean =>
    this.props.form.isBase && !this.props.completed

  onClick = () => {
    const {
      completed,
      form,
      history,
      plusUser,
      patientDetail,
      openEvaluationWarningModal
    } = this.props
    const isPlusUser = plusUser

    if (
      patientDetail.currentAssessment !==
      patientDetail.assessments.relevant_assessment
    ) {
      openEvaluationWarningModal()
    } else if (completed) {
      if (isPlusUser) {
        this.setState({ progressionEvaluationModalOpen: true })
      }
    } else {
      history.push(`/questionnaires`, form.type)
    }
  }

  onSend = (e: React.MouseEvent) => {
    SnackbarService.showSnackbar(
      'Distribute Questionnaires feature is coming soon!',
      'info'
    )
    e.stopPropagation()
  }

  renderGameInstallationModal() {
    const { user } = this.props
    const { gameInstallationModalOpen } = this.state

    return (
      <GameInstallationModal
        open={gameInstallationModalOpen}
        onClose={() => this.setState({ gameInstallationModalOpen: false })}
        user={user}
      />
    )
  }

  renderProggressionEvaluationModal() {
    const { history, patientDetail, user } = this.props
    const gamesCount = getGamesCount(patientDetail)
    const questionnairesCount = getQuestionnairesCount(patientDetail)
    const { progressionEvaluationModalOpen } = this.state
    const showQuestionnaries = true
    const showGames = questionnairesCount === 0
    const currentPath = location.pathname

    const pushToGamesPage = () => {
      history.push(_route.games(patientDetail.patientId), {
        userCameFromQuestionnaires: true
      })
    }
    const getGamesApp = () => {
      if (isMobile && user.logged_in_game) {
        //   window.location.href = `uniwebview://action?cid=${patientDetail.patientId}&cname=${patientDetail.first_name}`
        // } else {
        this.setState({
          progressionEvaluationModalOpen: false,
          gameInstallationModalOpen: true
        })
      }
    }

    return (
      progressionEvaluationModalOpen && (
        <ProgressionEvaluationModal
          age={getAge(patientDetail.birth_date)}
          open={progressionEvaluationModalOpen}
          questionnairesCount={questionnairesCount}
          gamesCount={gamesCount}
          showGames={showGames}
          showQuestionnaries={showQuestionnaries}
          onClose={() => {
            this.setState({ progressionEvaluationModalOpen: false })
          }}
          onSubmit={() => {
            if (showQuestionnaries && questionnairesCount !== 0) {
              history.replace('/questionnaires', true)
            } else if (showGames && gamesCount !== 0) {
              const {
                history: { location }
              } = this.props

              location.state = {
                ...(location.state as object),
                fromModal: true
              }
              currentPath === _route.questionnaires(patientDetail.patientId)
                ? pushToGamesPage()
                : getGamesApp()

              // uniweb
              // window.location.href = `uniwebview://action?cid=${patientDetail.patientId}&cname=${patientDetail.first_name}`
            } else {
              this.setState({ progressionEvaluationModalOpen: false })
              history.push(_route.abilities(patientDetail.patientId))
            }
          }}
          history={history}
          relevantAssessment={patientDetail.assessments.relevant_assessment}
        />
      )
    )
  }

  render() {
    const { form, completed, plusUser, openPlusOnlyPopup } = this.props
    const completedImages = this.getImages([], true)
    const pendingImages = this.getImages([], false)
    const responseMissing = this.baseResponseMissing()
    completed ? completedImages.push(parentImg) : pendingImages.push(parentImg)
    const canAnswer = ['self-esteem'].includes(form.type)

    return (
      <div>
        <Content
          title={form.title}
          description={form.description}
          // pendingImages={pendingImages}
          // completedImages={completedImages}
          responseMissing={responseMissing}
          onClick={plusUser || canAnswer ? this.onClick : openPlusOnlyPopup}
          plusUser={plusUser || canAnswer}
          onSend={this.onSend}
        />
        {this.renderProggressionEvaluationModal()}
        {this.renderGameInstallationModal()}
      </div>
    )
  }
}

const WithRouter = withRouter(PatientForm)

const mapStateToProps = state => {
  return {
    patientDetail: state.patients.currentPatient,
    user: state.user.data,
    plusUser: state.plus_user.isPlusUser
  }
}
export default connect(mapStateToProps)(WithRouter)



// WEBPACK FOOTER //
// ./src/pages/EvaluationQuestionnaires/PatientForm/index.tsx